import { FAVORITE_CATEGORY } from '../../../constants';
import { getFavoritesList } from '../../../utils';
import { parseFavorites } from '../../normalize';
import { GamesStorageType, SetFavoriteListArgs } from '../../types';

type SetFavoriteListPreparator = (
  args: SetFavoriteListArgs & { state: GamesStorageType }
) => GamesStorageType;

export const setFavoriteListStatePreparator: SetFavoriteListPreparator = ({
  gamesList,
  entityName,
  isGameDeleted,
  isGameAdded,
  state
}) => {
  const parsedFavorites = parseFavorites(gamesList);
  const newFavoritesList = getFavoritesList(
    state.favorites[entityName]?.ids || [],
    parsedFavorites,
    !isGameDeleted
  );

  // handling plex-pagination for favorites, when modifying them while on favorites page
  let updatedPaginationObj = { ...state.pagination };
  if (
    state.pagination.category.id === FAVORITE_CATEGORY.id &&
    (isGameAdded || isGameDeleted)
  ) {
    const [{ id: gameId }] = gamesList;

    updatedPaginationObj = {
      ...state.pagination,
      category: {
        ...state.pagination.category,
        gamesIds: isGameAdded
          ? [gameId, ...(state.pagination.category.gamesIds ?? [])]
          : state.pagination.category.gamesIds?.filter((id) => id !== gameId)
      }
    };
  }

  return {
    ...state,
    favorites: {
      ...state.favorites,
      [entityName]: {
        ids: newFavoritesList,
        isLoaded: true
      }
    },
    pagination: updatedPaginationObj
  };
};
